// TEMPL: loads the subscription free-flag logic on every page.
// Resolves against this file's own CDN directory, so no importmap entry needed.
//
// CAVEAT: a relative import like this resolves to a URL with no ?v= hash, and
// Shopify's asset CDN pins versionless URLs to their first build. If this file
// is ever edited and the change appears not to take effect, that is why — load
// it through asset_url from a Liquid snippet instead, as the subscription widget
// now does (see snippets/templ-subscription-widget.liquid).
// import './templ-subscription-gift.js';  // free-flag promo ended <8/22/2026>

// NOTE: templ-subscription-widget.js is deliberately NOT imported here. It is
// loaded via asset_url from snippets/templ-subscription-widget.liquid so its URL
// carries a version hash and edits actually propagate.

/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
